export const AOS_ANIMATION = {
  FADE_UP: {
    DURATION: "2000",
    TYPE: "fade-up",
  },
  FADE_LEFT: {
    DURATION: "2000",
    TYPE: "fade-left",
  },
  FADE_RIGHT: {
    DURATION: "1000",
    TYPE: "fade-right",
  },
  FLIP_LEFT: {
    DURATION: "1000",
    TYPE: "flip-left",
  },
};
